import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const VetSaudeLogo = styled.img`
  height: 75px !important;
  width: auto !important;
  cursor: pointer;

  @media (min-width: 767px) {
    height: 100px !important;
    width: auto !important;
  }
`;

export const PlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: #f6f6f6;
  height: 200px;
  align-items: center;
  -webkit-box-shadow: inset 0px 0px 67px -53px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: inset 0px 0px 67px -53px rgba(0, 0, 0, 0.75);
  box-shadow: inset 0px 0px 67px -53px rgba(0, 0, 0, 0.75);

  @media (min-width: 767px) {
    display: flex;
    flex-direction: row;
  }
`;

export const PlanIdentifier = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PlanTittle = styled.p`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 20pt;
  color: #000000;
`;

export const PlanValue = styled.p`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 14pt;
  color: #39a9dc;
`;

export const PlanSubValue = styled.p`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 10pt;
  color: #39a9dc;
`;
